import type { ComputedRef } from 'vue'

import { DateFormat } from '@brighterly/lib-core-types/date/enums'

import dayjs from 'dayjs'

import { useAdminRoutes } from '@shared/lib/routes'

import { useTasksKanbanStore } from './store'

interface TaskCommonReturn {
  refCreatedAt: ComputedRef<string>
  refUpdatedAt: ComputedRef<string>
  refHasCreator: ComputedRef<boolean>
  refCreatorName: ComputedRef<string>
  refCreatorHref: ComputedRef<string>
}

const formatDate = (value: string | null): string => {
  if (!value) return ''
  const parsed = dayjs(value, DateFormat.Default)
  if (!parsed.isValid()) return ''
  return parsed.format(DateFormat.KanbanDate)
}

export const useTaskCommon = (): TaskCommonReturn => {
  const tasksKanbanStore = useTasksKanbanStore()

  const refCreatedAt = computed<string>(() => formatDate(tasksKanbanStore.getCreatedAt))
  const refUpdatedAt = computed<string>(() => formatDate(tasksKanbanStore.getUpdatedAt))

  const refHasCreator = computed<boolean>(() => !!tasksKanbanStore.getCreator)
  const refCreatorName = computed<string>(() => tasksKanbanStore.getCreator?.name ?? '')
  const refCreatorHref = computed<string>(() => {
    const creator = tasksKanbanStore.getCreator
    if (!creator) return ''
    return useAdminRoutes('admin.user.show', { user_id: creator.id }) ?? ''
  })

  return {
    refCreatedAt,
    refUpdatedAt,
    refHasCreator,
    refCreatorName,
    refCreatorHref,
  }
}
